// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lQvQ","colMin":"styles_colMin__29Omr"};